import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import { TableRadioButton, DialogSaveButton } from "../../../common/Global/globalStyles.style";
import { isEmptyVariable, isEmptyArray } from "../../../common/Global/commonFunctions";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../../common/AlertDialog";
class AssertionAssignmentList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRiskId: "",
			// selectedRiskObj: {},
			riskErr: "",
			selectedLikelihoodId: "",
			likelihoodRiskErr: "",
			showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
			likelihoodRiskMatrix:[]
		};
	}

	componentDidMount() {}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showRiskDialog) {
			// let selectedObj=this.props.selectedRiskObj;
			let selectedRiskId = isEmptyVariable(this.props.selectedRiskId) ? "" : this.props.selectedRiskId;
			let selectedLikelihoodId = isEmptyVariable(this.props.selectedLikelihoodRiskId) ? "" : this.props.selectedLikelihoodRiskId;
			let isLikelihood = this.props.isLikelihood ?? false;
			this.setState({
				selectedRiskId: selectedRiskId,
				// selectedRiskObj:selectedObj,
				riskErr: "",
				assignmentRiskId:this.props.assignmentRiskId,
				selectedLikelihoodId: selectedLikelihoodId,
				isLikelihood:isLikelihood,
				assignmentLikelihoodId:this.props.assignmentLikelihoodId,
				likelihoodRiskMatrix:this.props.likelihoodRiskMatrix ?? []
			});
		}
	}

	handleSelection = (e) => {
		// e.stopPropagation();
		let isChecked = e.target.checked;
		let riskLevelArrIndex = e.target.name;
		let selectedRiskId = "";
		// let selectedRiskObj = {};

		if (isChecked) {
			selectedRiskId = this.props.riskArr[riskLevelArrIndex].riskLevelId;
			// selectedRiskObj = this.props.riskArr[riskLevelArrIndex];
		}

		this.setState({
			selectedRiskId: selectedRiskId,
			// selectedRiskObj:selectedRiskObj
		});
	};

	handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

	clearRisk = () => {
		this.setState({
			selectedRiskId: null,
			riskErr: "",
			selectedLikelihoodId: null,
			likelihoodRiskErr: ""
		},() => {
			if(!isEmptyVariable(this.props.selectedRiskId) || !isEmptyVariable(this.props.selectedLikelihoodRiskId)){
				this.props.handleSelectRiskDialogSaveClose(this.state.selectedRiskId, this.state.selectedLikelihoodId);
			}else{
				// this.props.handleSelectRiskDialogClose(false);
			}
		});
	}

	returnSelectedRiskId = () => {
		let riskErrTemp = "", likelihoodRiskErrTemp = "";

		if (isEmptyVariable(this.state.selectedRiskId) && !isEmptyVariable(this.state.assignmentRiskId)) {
			riskErrTemp = "Select the risk level";
			this.setState({
				riskErr: riskErrTemp
			});

			setTimeout(
				function () {
					this.setState({
						riskErr: "",
					});
				}.bind(this),
				Constants.WRNG_MSG_TIMEOUT
			);
		}

		if (this.state.isLikelihood && isEmptyVariable(this.state.selectedLikelihoodId) && 
		!isEmptyVariable(this.state.assignmentLikelihoodId)) {
			likelihoodRiskErrTemp = "Select the likelihood level";

			this.setState({
				likelihoodRiskErr: likelihoodRiskErrTemp,
			});

			setTimeout(
				function () {
					this.setState({
						likelihoodRiskErr: "",
					});
				}.bind(this),
				Constants.WRNG_MSG_TIMEOUT
			);
		}
		// isLikelihood used to check if the likelihood setting is enabled or not
		// selectedRiskId empty and likelihood not empty
		// selectedRiskId is used to check if the risk is selected or not
		// assignmentLikelihoodId is used to check if the schedule assignment inside a likelihood assigned or not
		if((!isEmptyVariable(this.state.selectedRiskId) && !this.state.isLikelihood) || 
		(isEmptyVariable(this.state.selectedRiskId) && isEmptyVariable(this.state.assignmentRiskId) && this.state.isLikelihood && !isEmptyVariable(this.state.selectedLikelihoodId)) ||
		(!isEmptyVariable(this.state.selectedRiskId) && this.state.isLikelihood && isEmptyVariable(this.state.assignmentLikelihoodId)) || 
		(!isEmptyVariable(this.state.selectedRiskId) && this.state.isLikelihood && !isEmptyVariable(this.state.selectedLikelihoodId))) {
			this.props.handleSelectRiskDialogSaveClose(this.state.selectedRiskId, this.state.selectedLikelihoodId);
		}
	};

	handleSelectionLikelihood = (e) => {
		let isChecked = e.target.checked;
		let likelihoodLevelArrIndex = e.target.name;
		let selectedLikelihoodId = "";

		if (isChecked) {
			selectedLikelihoodId = this.state.likelihoodRiskMatrix[likelihoodLevelArrIndex].riskLevelId;
		}

		this.setState({
			selectedLikelihoodId: selectedLikelihoodId,
		});
	};
	/*****************************API*********************************/
	render() {
		return (
			<section>
				<Modal className="custom-dialog" show={this.props.showRiskDialog} size={this.state.isLikelihood && !isEmptyArray(this.state.likelihoodRiskMatrix)?"lg":"md"} backdrop="static">
					<Modal.Header>
						<h5>Risk Level</h5>
						<button onClick={this.props.handleSelectRiskDialogClose} type="button" data-dismiss="modal">
							<span class="material-icons">close</span>
						</button>
					</Modal.Header>
					<hr />
					<div className="modal-body">
						<div className="body-wrapper">
							<div className="row">
								<div className={this.state.isLikelihood && !isEmptyArray(this.state.likelihoodRiskMatrix)?"col-md-6":"col-md-12"}>
									{isEmptyArray(this.props.riskArr) ?
									 (
										<div class="no-items-layout">
											<div class="no-items-card">
												<h6>No risk levels found</h6>
											</div>
										</div>
									 ) : (
										<div>
											<div className="common-tab-bg">
												<div className="common-table" style={{ width: "100%", border: "1px solid #e5e5e5" }}>
													<table className="table">
														<thead>
															<tr>
																<th className="text-center" width={"8%"}></th>
																<th>Risk Level</th>
																<th>Color Code</th>
															</tr>
														</thead>
														<tbody>
															{this.props.riskArr.map((item, idx) => {
																return (
																	<tr>
																		<td>
																			<TableRadioButton themeSettings={this.props.themeSettings}>
																				<input
																					type="checkbox"
																					name={idx}
																					id={item.riskLevelId}
																					onChange={this.handleSelection}
																					checked={item.riskLevelId + "" === this.state.selectedRiskId + "" ? true : false}
																				/>
																				<label for={item.riskLevelId} style={{ marginLeft: 6 }}></label>
																			</TableRadioButton>
																		</td>
																		<td>{item.riskLevel}</td>
																		<td>
																			<div className="risk-level-color-wrapper" style={{ width: "38px" }}>
																				<div className="risk-level-color" style={{ background: item.colorCode }} />
																			</div>
																		</td>
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>
											</div>
											{!isEmptyVariable(this.state.riskErr) && <span className="cm-error">{this.state.riskErr}</span>}
										</div>
									)}
								</div>
								{this.state.isLikelihood && !isEmptyArray(this.state.likelihoodRiskMatrix) &&
									<div className="col-md-6">
										<div>
											<div className="common-tab-bg">
												<div className="common-table" style={{ width: "100%", border: "1px solid #e5e5e5" }}>
													<table className="table">
														<thead>
															<tr>
																<th className="text-center" width={"8%"}></th>
																<th>Likelihood Level</th>
																<th>Color Code</th>
															</tr>
														</thead>
														<tbody>
															{this.state.likelihoodRiskMatrix.map((item, idx) => {
																return (
																	<tr>
																		<td>
																			<TableRadioButton themeSettings={this.props.themeSettings}>
																				<input
																					type="checkbox"
																					name={idx}
																					id={"likelihood_" + item.riskLevelId}
																					onChange={this.handleSelectionLikelihood}
																					checked={item.riskLevelId + "" === this.state.selectedLikelihoodId + "" ? true : false}
																				/>
																				<label for={"likelihood_" + item.riskLevelId} style={{ marginLeft: 6 }}></label>
																			</TableRadioButton>
																		</td>
																		<td>{item.riskLevel}</td>
																		<td>
																			<div className="risk-level-color-wrapper" style={{ width: "38px" }}>
																				<div className="risk-level-color" style={{ background: item.colorCode }} />
																			</div>
																		</td>
																	</tr>
																);
															})}
														</tbody>
													</table>
												</div>
											</div>
											{!isEmptyVariable(this.state.likelihoodRiskErr) && <span className="cm-error">{this.state.likelihoodRiskErr}</span>}
										</div>
									</div>
								}
							</div>
							{/* )} */}
							{/* {!isEmptyVariable(this.state.riskErr) && <span className="cm-error">{this.state.riskErr}</span>} */}
							<div className="modal-close-save m-t-15">
								<div className="close-save-col">
									<button onClick={this.props.handleSelectRiskDialogClose} type="button" className="modal-close m-b-0">
										Cancel
									</button>
									{(!isEmptyVariable(this.state.selectedRiskId) || !isEmptyVariable(this.state.selectedLikelihoodId)) &&
										<button onClick={() => this.clearRisk()} type="button" className="modal-close m-b-0">
											Clear
										</button>
									}
									<DialogSaveButton
										themeSettings={this.props.themeSettings}
										onClick={this.returnSelectedRiskId}
										type="button"
										className="modal-save m-b-0"
									>
										Save
									</DialogSaveButton>
								</div>
							</div>
						</div>
					</div>
				</Modal>
				<AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
			</section>
		);
	}
}

export default AssertionAssignmentList;
